import React from 'react';
import { func, string, bool, any } from 'prop-types';
import classNames from 'classnames';

import './index.scss';

const Tab = ({
    title,
    active = false,
    onClick = Function.prototype,
    className
}) => (
    <li className={classNames('orca-tab text-semi-bold', className, { active })} onClick={onClick}>
        {title}
    </li>
);

Tab.displayName = 'Tab';

Tab.propTypes = {

    /**
     * Tab title
     */
    title: any.isRequired,

    /**
     * Whether the tab is selected
     */
    active: bool,

    /**
     * onClick event handler
     */
    onClick: func,

    /**
     * Custom class name
     */
    className: string
};

Tab.defaultProps = {
    active: false
};

export default Tab;
